export default "__VITE_ASSET__BWHPgC$y__"